import React from "react";
import { PlayAreaProps } from "./Interfaces";
import { PlayAreaDesktopButton } from './PlayAreaDesktopButton'

import '../../scss/play-area-desktop.scss'
import { BetType } from "./Enums";

class PlayAreaDesktop extends React.Component<PlayAreaProps>{

    private btLeft = React.createRef<PlayAreaDesktopButton>();
    private btRight = React.createRef<PlayAreaDesktopButton>();

    componentDidMount = () => {
        this.shoHideButtons(true);
    }

    private makeBet = (bet: BetType) => {
        this.props.makeBetHandler(bet);
        this.shoHideButtons(false);
    }

    public shoHideButtons = (show: boolean) => {

        const position = show ? -(window.innerWidth * 0.9) * 0.032 : window.innerWidth;
        const opacity = show ? 1 : 0;

        this.btLeft.current.move(-position , opacity, 1);
        this.btRight.current.move(+position , opacity, 1);
    }

    render() {
        return (
            <div className="play-area-desktop">
                <PlayAreaDesktopButton
                    ref={this.btLeft}
                    scssClass="bt-game-desktop-left"
                    makeBet={this.makeBet}
                    openContest={this.props.openContest}
                    type={BetType.closeBellow}
                />
               <PlayAreaDesktopButton
                    ref={this.btRight}
                    scssClass="bt-game-desktop-right"
                    makeBet={this.makeBet}
                    openContest={this.props.openContest}
                    type={BetType.closeAbove}
                />
            </div>
        )
    }

}

export default PlayAreaDesktop;